
import { defineComponent } from 'vue'
import OuterOutputSelect from '@/components/organisms/dms/OuterOutputSelect/OuterOutputSelect.vue'
export default defineComponent({
  components: {
    OuterOutputSelect
  }
})
